export const figure28 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      colors: ['#bfbfbf','#ff0000','#00b050'],

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
          },
          column: {
              stacking: 'percent'
          }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ "Afrique subsaharienne", "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)", "Asie centrale et Asie du Sud", "Afrique du Nord et Asie de l’Ouest", "Amérique latine et Caraïbes", "Asie de l’Est et Asie du Sud-Est", "Europe et Amérique du Nord", "Australie et Nouvelle-Zélande", "Monde"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
			    style: {
					   textOverflow: 'none',
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: {
			    labels: {
					    format: '{value}',
					    formatter: function () {
	    // should be return this.value + '.00%'; but doesn't fit
							    return this.value + '';
						    },
				    },
	min: 0,
	max: 100,
	tickInterval: 20,
        title: {
            text: ''
        }
    },
    tooltip: {
			    shared: false,
			    formatter: function () {
					    if (this.series.name === 'Races locales dont le statut vis-à-vis du risque est inconnu') {
						    return false; 
					    }    
					    return '<span style="color:' + this.series.color + '">' + this.series.name + '</span>: <b>' + this.point.y + '</b> (' + this.point.percentage.toFixed(0) + '%)<br/>';
				    }
		    },
    legend: {
        enabled: false,
      },
 
      series: [
        {
            name: 'Races locales dont le statut vis-à-vis du risque est inconnu',
            color: '#bfbfbf',
	    data: [ 659, 64, 558, 412, 472, 992, 1213, 24, 4394 ],
	    dataLabels: {
			  enabled: false,
		  },
        },
        {
          name: 'Races locales en danger d’extinction',
          color: '#ff0c00',
          data: [ 37, 0, 34, 21, 37, 53, 1631, 58, 1871]
      },
        {
            name: 'Races locales n’étant pas en danger d’extinction',
            color: '#0eb050',
            data: [ 78, 0, 151, 65, 59, 88, 353, 9, 803 ]
        },
       
      ]
}
